(function() {
    // Configuration
    const APP_URL = 'https://api.sweans.org/tapwise-app';
    const appInfoElement = document.getElementById('app-info-rni');
    
    // Validate required elements exist
    if (!appInfoElement) {
        console.error('SSO Login: app-info-rni element not found');
        return;
    }
    
    const SHOP_DOMAIN = appInfoElement.getAttribute('data-shop-url');
    const ACTION = appInfoElement.getAttribute('data-app-action');
    
    // Validate required configuration
    if (!SHOP_DOMAIN || !ACTION) {
        console.error('SSO Login: Missing required configuration (shop-url or app-action)');
        return;
    }

    let checkInterval = null;
    let timeout = null;
    let isProcessing = false; // Prevent duplicate processing

    // Function to get cookie value
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }
    
    // Function to capture login credentials and authenticate with API
    function captureLogin(email, password, originalButton) {
        if (isProcessing) {
            console.log('SSO Login: Already processing, ignoring duplicate request');
            return;
        }
        
        isProcessing = true;
        
        // Set a timeout for the API request
        timeout = setTimeout(() => {
            console.warn('SSO Login: API request timeout');
            isProcessing = false;
            clickOriginalButton(originalButton);
        }, 15000); // Increased to 15 seconds for slower mobile connections
        
        // Make the API request
        fetch(`${APP_URL}/api/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                email: email,
                password: password,
                shopDomain: SHOP_DOMAIN,
                action: ACTION
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            clearTimeout(timeout);
            
            if (data.success) {
                // Store auth token and user info
                localStorage.setItem('sso_auth_token', data.authToken);
                localStorage.setItem('sso_user_email', email);
                localStorage.setItem('auth_token_expires_at', data.authTokenExpiresAt);
                localStorage.setItem('customer_token_expires_at', data.customerTokenExpiresAt);
                console.log('SSO Login: Authentication successful');
            } else {
                console.warn('SSO Login: Authentication failed', data);
            }
            
            // Wait a bit longer on mobile to ensure storage is written
            setTimeout(() => {
                isProcessing = false;
                clickOriginalButton(originalButton);
            }, 600);
        })
        .catch(error => {
            console.error('SSO Login: API error:', error);
            clearTimeout(timeout);
            isProcessing = false;
            clickOriginalButton(originalButton);
        });
    }
    
    // Helper function to click the original Shopify login button
    function clickOriginalButton(originalButton) {
        // Remove loading class
        if (originalButton && originalButton.classList.contains('loading')) {
            originalButton.classList.remove('loading');
        }
        
        // Remove our event listener temporarily to avoid infinite loop
        if (originalButton && originalButton.ssoClickHandler) {
            originalButton.removeEventListener('click', originalButton.ssoClickHandler, true);
        }
        
        // Find and click the original Shopify login button
        const shopifyLoginButton = document.getElementById('shopify-login-button');
        if (shopifyLoginButton) {
            // Use setTimeout to ensure it happens after current event completes
            setTimeout(() => {
                shopifyLoginButton.click();
            }, 50);
        } else {
            // Fallback: submit the form directly
            const credentials = findLoginCredentials();
            console.log(credentials)
            if (credentials && credentials.form) {
                setTimeout(() => {
                    credentials.form.submit();
                }, 50);
            }
        }
        
        // Re-attach our event listener after a delay
        setTimeout(() => {
            if (originalButton && originalButton.ssoClickHandler) {
                originalButton.addEventListener('click', originalButton.ssoClickHandler, true);
            }
        }, 500); // Increased delay for mobile
    }
    
    // Function to find login form and extract credentials
    function findLoginCredentials() {
        // Look for login forms - more specific selectors first
        const loginForms = document.querySelectorAll(
            'form[action*="account/login"], ' +
            'form[action="/account/login"], ' +
            '#customer_login, ' +
            '.login-form, ' +
            'form'
        );
        
        for (let i = 0; i < loginForms.length; i++) {
            const form = loginForms[i];
            
            // Find email and password fields
            const emailField = form.querySelector(
                'input[name="customer[email]"], ' +
                'input[type="email"], ' +
                'input[name="email"], ' +
                'input[placeholder*="email" i]'
            );
            const passwordField = form.querySelector(
                'input[name="customer[password]"], ' +
                'input[type="password"], ' +
                'input[name="password"], ' +
                'input[placeholder*="password" i]'
            );
            
            if (emailField && passwordField) {
                // Mobile keyboard might not have triggered blur/change events yet
                // Force value retrieval
                const email = emailField.value.trim();
                const password = passwordField.value;
                
                if (email && password) {
                    return {
                        email: email,
                        password: password,
                        form: form
                    };
                }
            }
        }
        
        return null;
    }
    
    // Function to initialize SSO button capture
    function initializeSSOButtonCapture() {
        const ssoButton = document.getElementById('sso-login-button-rni');
        
        if (!ssoButton) {
            return false;
        }
        
        // Skip if already processed
        if (ssoButton.dataset.ssoProcessed) {
            return true;
        }
        
        ssoButton.dataset.ssoProcessed = 'true';
        
        // Create a click handler function
        // Use capture phase and multiple event types for better mobile support
        ssoButton.ssoClickHandler = function(e) {
            console.log('SSO Login: Button clicked');
            
            // Prevent the default button action
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            if (!ssoButton.classList.contains('loading')) {
                ssoButton.classList.add('loading');
            }
            
            // On mobile, input fields might not have blurred yet
            // Force blur on all input fields to ensure values are updated
            const allInputs = document.querySelectorAll('input[type="email"], input[type="password"]');
            allInputs.forEach(input => {
                if (document.activeElement === input) {
                    input.blur();
                }
            });
            
            // Small delay to ensure blur events complete on mobile
            setTimeout(() => {
                // Find login credentials
                const credentials = findLoginCredentials();
                
                if (credentials) {
                    console.log('SSO Login: Credentials found, authenticating...');
                    // Capture the credentials and handle the flow
                    captureLogin(credentials.email, credentials.password, ssoButton);
                } else {
                    console.warn('SSO Login: No credentials found, proceeding with original action');
                    // If no credentials found, allow the original action
                    isProcessing = false;
                    clickOriginalButton(ssoButton);
                }
            }, 100); // Small delay for mobile input handling
        };
        
        // Add event listeners - use capture phase for better mobile support
        ssoButton.addEventListener('click', ssoButton.ssoClickHandler, true);
        // Also listen for touchend on mobile
        ssoButton.addEventListener('touchend', function(e) {
            // Prevent ghost clicks on mobile
            e.preventDefault();
            ssoButton.ssoClickHandler(e);
        }, true);
        
        console.log('SSO Login: Button initialized');
        return true;
    }
    
    // Function to initialize login form capture
    function initializeCapture() {
        // Try to initialize SSO button capture
        initializeSSOButtonCapture();
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initializeCapture();
        });
    } else {
        initializeCapture();
    }
    
    // Periodic check for dynamically added button
    checkInterval = setInterval(function() {
        const ssoButton = document.getElementById('sso-login-button-rni');
        if (ssoButton && !ssoButton.dataset.ssoProcessed) {
            initializeCapture();
        }
    }, 2000);
    
    // Clean up interval after 30 seconds to prevent unnecessary checks
    setTimeout(function() {
        if (checkInterval) {
            clearInterval(checkInterval);
        }
    }, 30000);
    
    // Re-initialize when navigation occurs (for SPA-like themes)
    let lastUrl = location.href;
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            setTimeout(function() {
                initializeCapture();
            }, 500);
        }
    }).observe(document, { subtree: true, childList: true });
    // Prevent Enter key from directly submitting the form
    const loginForm = document.querySelector('form[action*="account/login"],#create_customer');

    if (loginForm) {
    loginForm.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
        e.preventDefault(); // stop native form submission
        // Optionally trigger your proxy button click instead:
        const proxyButton = document.getElementById('sso-login-button-rni');
        if (proxyButton) {
            proxyButton.click();
        }
        }
    });
    }

})();